export default {
    createUniversityEvent: '/universityEvents/createUniversityEvent',
    getUniversityEvent: '/universityEvents/getUniversityEvent',
    updateUniversityEvent: '/universityEvents/updateUniversityEvent',
    deleteEvent: '/universityEvents/deleteEvent',
  }
  